<fieldset ngModelGroup="login_type_office365">
    <hr class="row mb-0"/>
    <div class="row">
        <div class="offset-sm-8 col-sm-40">
            <h3 class="font-weight-300" translate>Office 365 (BETA)</h3>
        </div>
    </div>
    <div class="form-group row">
        <label for="domain_login_office365_email"
               [ngbTooltip]="'Email to login' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-sm-8"
               translate>
            Email
        </label>
        <div class="col-sm-40">
            <input id="domain_login_office365_email"
                   #domainLoginOffice365Email="ngModel"
                   name="domain_login_office365_email"
                   type="email"
                   class="form-control"
                   required
                   [(ngModel)]="login.office365.email"
                   (ngModelChange)="loginChange.emit(login)"/>
        </div>
        <form-field-errors offset="0" [input]="domainLoginOffice365Email"></form-field-errors>
    </div>
    <div class="form-group row">
        <label for="domain_login_office365_password"
               [ngbTooltip]="'Password to login' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-sm-8"
               translate>
            Password
        </label>
        <div class="col-sm-40">
            <input id="domain_login_office365_password"
                   #domainLoginOffice365Password="ngModel"
                   name="domain_login_office365_password"
                   type="password"
                   class="form-control"
                   required
                   [(ngModel)]="login.office365.password"
                   (ngModelChange)="loginChange.emit(login)"/>
        </div>
        <form-field-errors offset="0" [input]="domainLoginOffice365Password"></form-field-errors>
    </div>
    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" for="office365_remember_me_step" translate>
            Remember me
        </label>
        <div class="col-sm-40">
            <form-field-material-switch name="office365_remember_me_step"
                                        [(ngModel)]="login.office365.remember_me_step"
                                        (ngModelChange)="loginChange.emit(login)">
            </form-field-material-switch>
        </div>
    </div>
</fieldset>
